
import Icon from 'icons/Icon'
import React, { useContext } from 'react'

const GenderField = ({ formik, contextValue }) => {
  const { languageData } = useContext(contextValue)
  const { values, handleChange, handleBlur } = formik
  return (
    <div className='radio-btn-design'>
      <label htmlFor='male' className='radio-btn'>
        <Icon name={values.gender === 'Male' ? 'radio-active' : 'radio-inactive'} width='auto' />
        {languageData?.signupMan}
        <input
          type='radio'
          id='male'
          name='gender'
          value='Male'
          onChange={handleChange}
          onBlur={handleBlur}
          defaultChecked={values.gender === 'Male'}
        />
      </label>

      <label htmlFor='female' className='radio-btn'>
        <Icon name={values.gender === 'Female' ? 'radio-active' : 'radio-inactive'} width='auto' />
        {languageData?.signupWomen}
        <input
          type='radio'
          id='female'
          name='gender'
          value='Female'
          onChange={handleChange}
          onBlur={handleBlur}
          defaultChecked={values.gender === 'Female'}
        />
      </label>
    </div>
  )
}

export default GenderField
